{
	"empty": "No hay datos para mostrar",
	"table": "Tabla"
}
